import EditIcon from "@mui/icons-material/Edit";
import { Button, useNotify, useRecordContext, useRefresh } from "react-admin";
import FormModal from "server/components/Modals/FormModal";
import { SectionTitle } from "features/SectionTitle";
import dataProvider from "server/dataProvider";
import { doctoralRequests } from "api/doctoralApi";
import PersonalInfoSection from "../../ApprovedCandidacies/Enroll/PersonalInfoSection";
import NamesEnSection from "../../ApprovedCandidacies/Enroll/NamesEnSection";
import BirthSection from "../../ApprovedCandidacies/Enroll/BirthSection";

const toDateOnly = value => (value ? value.split("T")[0] : null);

const PersonalInfoEditDialog = () => {
  const record = useRecordContext();
  const notify = useNotify();
  const refresh = useRefresh();

  if (!record?.id) return null;

  const candidate = record.candidate || {};

  const handleConfirm = async data => {
    await dataProvider.customRequest(
      doctoralRequests.updateDoctorantPersonalInfo(record.id),
      {
        userInfo: {
          firstName: data.firstName,
          secondName: data.secondName,
          lastName: data.lastName,
          firstNameEn: data.firstNameEn,
          secondNameEn: data.secondNameEn,
          lastNameEn: data.lastNameEn,
          gender: data.gender,
          birthDate: toDateOnly(data.birthDate),
          birthCountryId: data.birthCountryId,
          birthSettlementId: data.birthSettlementId,
          birthSettlement: data.birthSettlement,
          contactPhone: data.contactPhone,
        },
      },
      "PUT",
    );
    notify("Личните данни са обновени успешно", { type: "success" });
    refresh();
  };

  return (
    <FormModal
      titleContent="Редакция на лични данни"
      saveTitle="Запази"
      dialogSize="md"
      onConfirm={handleConfirm}
      defaultValues={{
        firstName: candidate.firstName,
        secondName: candidate.secondName,
        lastName: candidate.lastName,
        firstNameEn: candidate.firstNameEn,
        secondNameEn: candidate.secondNameEn,
        lastNameEn: candidate.lastNameEn,
        gender: candidate.gender,
        birthDate: candidate.birthDate,
        birthCountryId: candidate.birthCountryId,
        birthSettlementId: candidate.birthSettlementId,
        birthSettlement: candidate.birthSettlement,
        contactPhone: candidate.contactPhone,
      }}
      triggerButton={
        <Button
          label="Редактирай"
          variant="outlined"
          size="small"
          startIcon={<EditIcon />}
        />
      }
    >
      <SectionTitle paddingY={2} title="Лични данни" />
      <PersonalInfoSection />

      <SectionTitle paddingY={2} title="Имена (латиница)" />
      <NamesEnSection />

      <SectionTitle paddingY={2} title="Месторождение" />
      <BirthSection />
    </FormModal>
  );
};

export default PersonalInfoEditDialog;
